"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasNavigator = hasNavigator;
const ExecutionEnvironmentUtils_1 = require("@gt/common-utils/build/general/ExecutionEnvironmentUtils");
function hasNavigator() {
    return ExecutionEnvironmentUtils_1.ExecutionEnvironmentUtils.isBrowser() && !(navigator?.geolocation == null);
}
